export default [{"id":"1","startTime":0,"endTime":4560,"text":"<b>Schauen Sie sich im folgenden Bereich gerne noch</b>\n<b>ganz in Ruhe um.</b>"}];